<template>
  <v-container fluid>
    <page-header @menuClick="menuChanged" :menuItems="menuItems">
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/teachers">Teachers</v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :to="backRoute">
          {{ teacher ? `${teacher.firstName} ${teacher.lastName}` : "N/A" }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
          New Time Record
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>
    <v-card
      v-if="timerecord && timerecord.staff_id"
      width="100%"
      class="mx-auto"
    >
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-select
                :items="centerList"
                v-model="timerecord.centerId"
                menu-props="auto"
                label="Location"
                hide-details
                item-text="name"
                item-value="id"
                prepend-icon="mdi-office-building-marker-outline"
                required
                :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <date-picker :key="timerecord.date" v-model="timerecord.date" :max="today" />
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                v-model="timerecord.time_in"
                label="Time In"
                hint="hh:mm am|pm format"
                prepend-icon="mdi-clock-time-four-outline"
                type="time"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                v-model="timerecord.time_out"
                label="Time Out"
                hint="hh:mm am|pm format"
                prepend-icon="mdi-clock-time-four-outline"
                type="time"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                prepend-icon="mdi-note"
                rows="1"
                :auto-grow="true"
                label="Comment"
                v-model="timerecord.comments"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :to="backRoute" class="mx-5">Cancel</v-btn>
          <v-btn @click="saveTimeRecord" color="primary" class="mx-5">{{
            timerecord.id ? "Update" : "Save"
          }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
    <v-sheet v-else>
      <choose-teacher v-model="teacher" @selected="changeTeacher" />
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { rules } from "@/store/util/rules.js";

const PageHeader = () => import("@/components/common/PageHeader.vue");
const DatePicker = () => import("@/components/common/DatePicker.vue");
const ChooseTeacher = () => import("@/components/teacher/ChooseTeacher.vue");

export default {
  data() {
    return {
      teacher: null,
      today: moment().format("YYYY-MM-DD"),
      timerecord: {
        centerId: null,
        staff_id: this.$route.params.teacherId,
        staff_type: "teacher",
        date: moment().format("YYYY-MM-DD"),
        time_in: moment().format("HH:mm"),
        time_out: moment().format("HH:mm"),
        comments: null
      },
      rules,
      menuItems: [
        {
          id: "change-staff",
          text: "Change Teacher",
          icon: "mdi-account-switch"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "myCenters"]),
    backRoute() {
      if (this.teacher) {
        return {
          name: "Teacher",
          params: { id: this.teacher.id, tab: "tab-attendance" }
        };
      } else {
        return null;
      }
    },
    centerList() {
      return this.myCenters.filter(c => c.id > 0);
    }
  },
  mounted() {
    // console.log("init time record")
    const teacherId = this.$route.params.teacherId
      ? this.$route.params.teacherId
      : null;
    this.initTeacher(teacherId).then(() => {
      this.initTimeRecord().then(record => {
        if(record){
          this.timerecord.id = record.id;
          this.timerecord.centerId = record.center.id;
          this.timerecord.date = moment(record.timeIn).format("YYYY-MM-DD");
          this.timerecord.time_in = moment(record.timeIn).format("HH:mm");
          this.timerecord.time_out = moment(record.timeOut).format("HH:mm");
          this.timerecord.comments = record.notes;
        }
      });
    });
  },
  components: {
    PageHeader,
    DatePicker,
    ChooseTeacher
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),
    async initTimeRecord() {
      const recordId = this.$route.params.id;
      if (!recordId) {
        return;
      }

      const url = `/timesheet/${recordId}`;
      return await this.$axios
        .get(url)
        .then(resp => {
          return resp.data;
        })
        .catch(error => {
          console.log(error);
          this.addErrorMessage("Error retrieving teacher's timesheet record");
        });
    },
    async initTeacher(teacherId) {
      console.log("teacher id: ", teacherId);
      if (teacherId) {
        return await this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then(resp => {
            this.teacher = resp.data.data;
            this.timerecord.staff_id = this.teacher.id;
            this.timerecord.staff_type = "teacher";

            return this.teacher;
          })
          .catch(() => {
            this.timerecord.staff_id = null;
            this.timerecord.staff_type = null;
          });
      }
    },
    menuChanged(event, menuItem) {
      if (menuItem.id == "change-staff") {
        this.timerecord.staff_id = null;
        this.teacher = null;
      }
    },
    changeTeacher(teacher) {
      this.initTeacher(teacher.id);
      // this.timerecord.staff_id = teacher.id;
      // this.timerecord.staff_type = "teacher";
      // this.backRoute.params.id = teacher.id;
    },
    saveTimeRecord() {
      if (!this.$refs.form.validate()) {
        this.addMessage("Please check your input");
        return;
      }
      this.timerecord.staff_id = this.teacher.id;
      console.log("posting time record: ", this.timerecord);
      this.$axios
        .post("/punch/manager-override/clock", this.timerecord)
        .then(resp => {
          this.rate = resp.data.data;
          this.addSuccessMessage("Staff time record updated");
          this.$router.push(this.backRoute);
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    }
  }
};
</script>

<style></style>
